// extracted by mini-css-extract-plugin
export default {"copyLinkFieldWrapper":"CopyContactRequestLinkTab_copyLinkFieldWrapper__SY5O6","textInputWrapper":"CopyContactRequestLinkTab_textInputWrapper__odicg"};